module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedThinItalic.1e6562c.woff";